jQuery(document).ready(function ($) {
    /**
     * First reorder all elements.
     */
    reOrderElements();

    /**
     * Runs when a variation is added.
     */
    $('#variation-add').change(function () {
        const selectedOption = $(this).find('option:selected');
        const variationId = selectedOption.val();
        const variationName = selectedOption.data('title');
        const maxStock = selectedOption.data('stock');
        const variationPrice = selectedOption.data('price');

        if (variationId !== "") {
            addVariationRow(variationId, variationName, maxStock, variationPrice);
            selectedOption.prop('disabled', true);
            $(this).val("");
            $('#variation-add').hide();
            $('#variation-add-option').show();
        }
    });

    $('#variation-add-option').click(function (e) {
        e.preventDefault();
        $('#variation-add').show();
        $('#variation-add-option').hide();
    });

    /**
     * Runs when we add the selection to our cart.
     */
    $('.custom-add-to-cart-form').submit(function (e) {
        e.preventDefault();
        const formData = $(this).serialize() + '&action=handleCustomCartMutations';

        $.ajax({
            type: 'POST',
            url: vakkappers_data.ajax_url,
            data: formData,
            success: function (response) {
                window.location.href = vakkappers_data.cart_url; // Cart fragments not refreshing, flatsome problem? Todo: refresh fragments instead.
            },
            error: function (xhr, status, error) {
                console.error(error);
            }
        });
    });

    /**
     * Adds the variation into the row container.
     * Front-end probably wants to move this to separate templates.
     *
     * @param variationId
     * @param variationName
     * @param maxStock
     */
    function addVariationRow(variationId, variationName, maxStock, variationPrice) {
        const newRow = $('<div class="variation-row">');
        const rowQty = $('<div class="quantity buttons_added">');
        newRow.append('<select name="variation-select[]" class="variation-select">' +
            '<option data-price="' + variationPrice + '" value="' + variationId + '">' + variationName + '</option>' +
            '</select>');
        rowQty.append('<input type="button" value="-" class="minus button is-form">');
        rowQty.append('<input type="number" name="quantity-input[]" class="quantity-input input-text qty text" aria-label="Productaantal" min="0" max="' + maxStock + '" value="1">');
        rowQty.append('<input type="button" value="+" class="plus button is-form">');
        newRow.append(rowQty);
        $('.variation-row-container').append(newRow);

        newRow.find('.minus').click(function () {
            const quantityInput = $(this).siblings('.quantity-input');
            const currentValue = parseInt(quantityInput.val(), 10);
            if (currentValue > 1) {
                quantityInput.val(currentValue - 1);
            } else if (currentValue === 1) {
                const selectedOption = newRow.find('.variation-select').find('option:selected');
                const selectedValue = selectedOption.val();

                $('#variation-add option').filter(function () {
                    return $(this).val() === selectedValue;
                }).prop('disabled', false);

                newRow.remove();
            }
        });

        newRow.find('.plus').click(function () {
            const quantityInput = $(this).siblings('.quantity-input');
            const currentValue = parseInt(quantityInput.val(), 10);
            if (currentValue < maxStock) {
                quantityInput.val(currentValue + 1);
            }
        });
    }

    /**
     * Frontend probably wants to make separate template files for this.
     *
     * @type {jQuery|HTMLElement|*}
     */
    function reOrderElements() {
        const wooCommercePriceWrapper = $('<div class="woocommerce-price-wrapper"></div>');
        const priceWrapperElement = $('.price.price-wrapper');
        const retailPriceWrapperElement = $('.retail-price').first();
        const stockStatusElement = $('.stock-status').first();
        const customAddToCartElement = $('#custom-form-submit');
        const customFormElement = $('.custom-add-to-cart-form');
        const uspElement = $('#single-product-usps');

        wooCommercePriceWrapper.append(priceWrapperElement);
        wooCommercePriceWrapper.append(retailPriceWrapperElement);
        wooCommercePriceWrapper.insertBefore(customFormElement);
        stockStatusElement.insertBefore(customAddToCartElement);
        uspElement.insertAfter(customAddToCartElement);
    }
});